import { API_DEV } from "constants/api";
import { header, handleAPIResult } from "utils";

export const optionService = {
  get: get,
  set: set,
};

function get(key) {
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/options/" + key, {
      method: "GET",
      headers: header(),
    })
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => resolve(result.value))
      .catch((error) => reject(error));
  });
}

function set(key, value) {
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/options/" + key, {
      method: "PUT",
      headers: { ...header(), "Content-Type": "application/json" },
      body: JSON.stringify({ value }),
    })
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => resolve(result.value))
      .catch((error) => reject(error));
  });
}
